import { object, string, array } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  evt_id: string().required(),
  token: string().required(),
  client_version: string().nullable().default('unknown'),
  init_subs: array().of(string().required()).required(),
});

/**
 * ClientHelloEvent
 *
 * - Esse evento é enviado pelo cliente como resposta ao evento `ClientHelloEvent`.
 * - O cliente deve enviar esse evento assim que receber o evento `ClientHelloEvent`.
 */
export class ClientHelloEvent extends CreateCommand(RealtimeEventType.ClientHello, SCHEMA) {}
